<div class="p-2">
    <!-- Title -->
    <div class="row pb-2">
        <div class="col-12 h5 text-muted p-0">Loyalty</div>
    </div>

    <div class="row bg-light p-2">
        <div class="col-12">

            <!-- Reports -->
            <div class="row pt-3 pb-1 mb-2 bg-white">
                <div class="col-12">
                    <div class="row text-center">
                        <div class="col-6 p-2">
                            <div class="card report-box bg-info text-white cursor-pointer"
                                (click)="showDetailedReportModal('customer-count', detailed_report_modal)">
                                <div class="card-body">
                                    <div class="title text-uppercase">Loyalty Customers</div>

                                    <div class="row">
                                        <div class="col-5">
                                            <div class="title">Total</div>
                                            <h2 class="card-title">{{ loyaltyCustomerCountData?.total | number }}</h2>
                                        </div>
                                        <div class="col-2">
                                            <div class="spinner-grow spinner-grow-sm text-white mt-2" role="status"
                                                *ngIf="loyaltyCustomerCountDataLoading === true"></div>
                                        </div>
                                        <div class="col-5">
                                            <div class="title">Last 30 Days</div>
                                            <h3 class="card-title">{{ loyaltyCustomerCountData?.daysTotal | number }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 p-2">
                            <div class="card report-box bg-info text-white cursor-pointer"
                                (click)="showDetailedReportModal('customer-sales', detailed_report_modal)">
                                <div class="card-body">
                                    <div class="title text-uppercase">Loyalty Sales</div>

                                    <div class="row">
                                        <div class="col-5">
                                            <div class="title">Total</div>
                                            <h2 class="card-title">{{ loyaltyCustomerSalesData?.total | currency }}
                                            </h2>
                                        </div>
                                        <div class="col-2">
                                            <div class="spinner-grow spinner-grow-sm text-white mt-2" role="status"
                                                *ngIf="loyaltyCustomerSalesDataLoading === true"></div>
                                        </div>
                                        <div class="col-5">
                                            <div class="title">Last 30 Days</div>
                                            <h3 class="card-title">{{ loyaltyCustomerSalesData?.daysTotal | currency }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loyalty programs 
        <div class="row pt-2 pb-2 bg-white">
            <div class="col-12">
                <div class="promotion-box">
                    <h3>Customer Welcome Promotion</h3>
                    <div class="promo-action">
                        <span>New customers will receive in-store dollars</span>

                        <button type="button" class="btn btn-secondary text-white" title="Activate">
                            Activate
                        </button>
                    </div>
                </div>
                <div class="promotion-box">
                    <h3>Customer Referral Promotion</h3>
                    <div class="promo-action">
                        <span>Customers will receive in-store dollars for referring new customers</span>
                        
                        <button type="button" class="btn btn-secondary text-white" title="Activate">
                            Activate
                        </button>
                    </div>
                </div>
                <div class="promotion-box">
                    <h3>Customer Points Program</h3>
                    <div class="promo-action">
                        <span>Customers can earn reward by accruing points during purchase</span>
                        
                        <button type="button" class="btn btn-secondary text-white" title="Activate">
                            Activate
                        </button>
                    </div>
                </div>
            </div>
        </div>-->

        </div>
    </div>
</div>

<!-- Detailed Report Modal -->
<ng-template #detailed_report_modal>
    <div class="modal-header">
        <h5 class="modal-title text-muted float-start">{{ detailedReportModalData.title }}</h5>
        <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close"
            (click)="hideDetailedReportModal()"></i-bs>
    </div>

    <div class="modal-body">
        <div class="row bg-light p-2">
            <div class="col-12">

                <!-- Filters -->
                <div class="row pt-3 pb-1 mb-2 bg-white">
                    <div class="col-6">
                        <div class="fs-6 fw-bold text-muted">
                            Date Range
                            <i-bs
                              name="infoCircle"
                              class="text-primary"
                              tooltip="Select from and to dates to filter report."
                              placement="top">
                            </i-bs>
                        </div>

                        <input type="text" class="form-control text-muted mt-2" placeholder="Select date range" bsDaterangepicker [bsConfig]="calendarConfig" [minDate]="calendarMinDate" [maxDate]="calendarMaxDate" [bsValue]="dateRange" (bsValueChange)="onCalendarValueChange($event)">
                    </div>
                    <div class="col-1">
                        <div class="fs-6 fw-bold text-muted">&nbsp;</div>
                        <div class="spinner-grow spinner-grow-sm text-info mt-3" role="status" *ngIf="loyaltyCustomerCountDataLoading === true"></div>
                        <div class="spinner-grow spinner-grow-sm text-info mt-3" role="status" *ngIf="loyaltyCustomerSalesDataLoading === true"></div>
                    </div>
                    <div class="col-5">
                        <div class="fs-6 fw-bold text-muted">&nbsp;</div>
                        <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold mt-2" title="Export Data" (click)="exportData(detailedReportModalData.mode)">
                            <i-bs class="text-light" name="filetypeCsv" width="20" height="20"></i-bs>&nbsp;&nbsp;Export Data
                        </button>
                    </div>
                </div>

                <!-- Chart -->
                <div class="row pt-3 pb-1 mb-2 bg-white">
                    <div class="col-12">
                        <app-chartjs-line 
                            [chartHeight]="detailedReportModalData.chartHeight" 
                            [showYAxisDollarValue]="detailedReportModalData.showYAxisDollarValue" 
                            [chartData]="detailedReportModalData.chartData">
                        </app-chartjs-line>
                    </div>
                </div>
    
            </div>
        </div>
    </div>
</ng-template>